(function () {
  window.ScrubLabTeams = window.ScrubLabTeams || {};

  const store = {
    root: null,

    state: {
      items: [],
      itemTarget: 5,
      discountPercentage: 10,

      drawer: {
        isOpen: false,
        productHandle: null,
        product: null,
        selectedOptions: []
      }
    },

    els: {},

    uid() {
      return Date.now().toString(36) + Math.random().toString(36).slice(2);
    },

    getTotalItems() {
      return this.state.items.reduce((total, item) => {
        return total + item.quantity;
      }, 0);
    },

    getSubtotal() {
      return this.state.items.reduce((total, item) => {
        return total + item.price * item.quantity;
      }, 0);
    },

    getEmbroiderySubtotal() {
  return this.state.items.reduce((total, item) => {
    const embroideryPrice = Number(item.embroidery?.price || 0);

    return total + embroideryPrice * item.quantity;
  }, 0);
},

    isDiscountUnlocked() {
      return this.getTotalItems() >= this.state.itemTarget;
    },

    getDiscountAmount() {
      if (!this.isDiscountUnlocked()) return 0;

      return Math.round(
        this.getSubtotal() * (this.state.discountPercentage / 100)
      );
    },

getTotal() {
  return (
    this.getSubtotal() -
    this.getDiscountAmount() +
    this.getEmbroiderySubtotal()
  );
},

    canAddVariantQuantity(variantId, productHandle, requestedQuantity) {
      const inventory = this.getVariantInventory(productHandle, variantId);

      // Don't impose limits when inventory data is unavailable.
      if (!inventory) return true;

      // Respect Shopify's inventory tracking and overselling settings.
      if (inventory.managed !== 'shopify' || inventory.policy === 'continue') {
        return true;
      }

      const alreadySelected = this.state.items.reduce((total, item) => {
        return String(item.variantId) === String(variantId)
          ? total + Number(item.quantity)
          : total;
      }, 0);

      const available = Math.max(0, Number(inventory.quantity) || 0);

      if (alreadySelected + requestedQuantity > available) {
        alert(
          `Only ${available} unit${available === 1 ? '' : 's'} available in this size. ` +
          `You already have ${alreadySelected} in your bundle.`
        );

        return false;
      }

      return true;
    },

    addItem(item) {
      if (!this.canAddVariantQuantity(
        item.variantId,
        item.productHandle,
        1
      )) {
        return;
      }

      this.state.items.push({
        id: this.uid(),
        quantity: 1,
        embroidery: null,
        ...item
      });

      this.closeDrawer();
      this.render();
    },

    updateItemQuantity(itemId, quantity) {
      const item = this.state.items.find((item) => {
        return item.id === itemId;
      });

      if (!item) return;

      if (quantity <= 0) {
        this.removeItem(itemId);
        return;
      }

      // Check inventory only when increasing quantity.
      if (quantity > item.quantity) {
        const additionalQuantity = quantity - item.quantity;

        if (!this.canAddVariantQuantity(
          item.variantId,
          item.productHandle,
          additionalQuantity
        )) {
          return;
        }
      }

      item.quantity = quantity;
      this.render();
    },

    removeItem(itemId) {
      this.state.items = this.state.items.filter((item) => {
        return item.id !== itemId;
      });

      this.render();
    }
  };

  window.ScrubLabTeams.store = store;
})();